/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useContext } from 'react';
import { UserIconButton } from 'blb-components/AuthenticatedApp/UserIconButton';
import ReactSVG from 'react-svg';
import { NavLinkButton } from 'blb-components/AuthenticatedApp/RON/SideBar/NavLinkButton';
import styled from 'styled-components';
import { Box } from 'grommet';
import { MeContext } from 'blb-contexts/Me';
import { BridgePermissions } from 'blb-types/blendBridge';
import { getConfig } from 'blb-utils/config';
import { matchPath, useHistory } from 'react-router';

const Logo = styled(ReactSVG)`
  height: 40px;
`;

export const NotarySidebar: React.FC<{}> = () => {
  const history = useHistory();
  const notaryNavLinks = [
    {
      iconType: 'calendar_today',
      label: 'NOTARIZATIONS',
      permission: BridgePermissions.BSRAppointments,
      redirectUrl: `${getConfig().ronUrl}/notary/rooms`,
    },
    {
      iconType: 'format_list_bulleted',
      label: 'JOURNAL',
      permission: BridgePermissions.BSRJournal,
      redirectUrl: `${getConfig().ronUrl}/notary/journal`,
    },
    {
      iconType: 'person',
      label: 'PROFILE',
      route: '/profile',
    },
    {
      iconType: 'person',
      label: 'NOTARIES',
      permission: BridgePermissions.BSRAdmin,
      route: '/notaries',
    },
  ];
  const me = useContext(MeContext);
  return (
    <Box data-it="NavigationSidebar" height="100vh" justify="between">
      <div>
        <Box margin={{ bottom: 'xlarge', top: 'xsmall' }} width="50%">
          <Logo path="./assets/blend-header-white.svg" />
        </Box>
        <div>
          {notaryNavLinks
            .filter(link => !link.permission || me?.permissions?.includes(link.permission))
            .map(notaryNavLink => {
              const route = notaryNavLink.route;
              const isActive = !!(route && matchPath(location.pathname, route));
              const onClick = () => {
                if (notaryNavLink.redirectUrl) {
                  window.location.href = notaryNavLink.redirectUrl;
                } else if (route) {
                  history.push(route);
                }
              };
              return (
                <NavLinkButton
                  data-it={`navLinkButton-${notaryNavLink.label}`}
                  iconType={notaryNavLink.iconType}
                  isActive={isActive}
                  key={notaryNavLink.label}
                  label={notaryNavLink.label}
                  onClick={onClick}
                />
              );
            })}
        </div>
      </div>
      <Box pad="xsmall">
        <UserIconButton showFullName={true} />
      </Box>
    </Box>
  );
};
